/**
 * @author AshutoshMaurya
 */

import setAuthorizationToken from './setAuthorizationToken';

const AUTH_TOKEN_KEY = '_flst';
const TEAM_KEY = '_tms';

const Token = {
  set: (val) => {
    localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(val));
  },
  setTeam: (val) => {
    localStorage.setItem(TEAM_KEY, JSON.stringify(val));
  },
  getTeam: () => {
    const item = localStorage.getItem(TEAM_KEY);
    return JSON.parse(item);
  },
  get: (key = AUTH_TOKEN_KEY) => {
    const item = localStorage.getItem(key);
    return JSON.parse(item);
  },
  remove: (key) => {
    localStorage.removeItem(key);
  },
  // Only removes auth-specific keys — preserves unrelated localStorage data
  clear: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(TEAM_KEY);
  },
  parsedToken: () => {
    const res = { success: false, data: null, message: '' };
    const token = Token.get(AUTH_TOKEN_KEY);

    if (!token) {
      res.message = 'No token found';
      return res;
    }
    const parts = token.split('.');
    if (parts.length < 2) {
      res.message = 'Invalid token format';
      return res;
    }
    try {
      res.success = true;
      res.message = 'Token parsed successfully';
      res.data = JSON.parse(window.atob(parts[1]));
    } catch (e) {
      res.success = false;
      res.message = 'Failed to parse token payload';
    }
    return res;
  },

  isExpired: () => {
    const parsed = Token.parsedToken();
    if (!parsed.success || !parsed.data?.exp) return true;
    return Date.now() / 1000 >= parsed.data.exp;
  },

  secondsUntilExpiry: () => {
    const parsed = Token.parsedToken();
    if (!parsed.success || !parsed.data?.exp) return 0;
    return Math.max(0, parsed.data.exp - Date.now() / 1000);
  },

  setAuthToken: () => {
    setAuthorizationToken(Token.get(AUTH_TOKEN_KEY));
  }
};

export default Token;
